<template>
  <header class="blog-detail__header">
    <div class="blog-detail__info">
      <span v-if="strapiData?.PublicationDate">
        {{ $d(new Date(strapiData.PublicationDate), 'long') || strapiData.PublicationDate }}
      </span>

      <span
        v-if="strapiData?.ReadingTime"
        class="blog-detail__reading-time"
      >
        -
        <IconClock class="icon icon--clock" />
        {{ strapiData.ReadingTime }} minuten
      </span>
    </div>

    <span
      v-if="strapiData?.Author?.Name && strapiData?.ParentPage?.PageTitle"
      class="blog-detail__author-name"
    >
      {{ strapiData.Author.Name }} in {{ strapiData.ParentPage.PageTitle }}
    </span>
  </header>
</template>

<script setup lang="ts">
defineProps<{
  strapiData: any
}>()
</script>

<style src="~layers/app/components/Blog/Header.css" />
